module.exports = __webpack_public_path__ + "assets/img/travel-day48.b5810b2d.png";